export default function SwooshDivider({ className = "" }) {
  return (
    <div className={`pointer-events-none relative overflow-hidden bg-ivory ${className}`} aria-hidden="true">
      <svg viewBox="0 0 1440 110" preserveAspectRatio="none" className="block h-16 w-full sm:h-24">
        <path
          d="M-20,90 C360,10 1080,10 1460,90"
          fill="none"
          stroke="#C5A059"
          strokeOpacity="0.55"
          strokeWidth="1.5"
        />
        <path
          d="M-20,98 C360,22 1080,22 1460,98"
          fill="none"
          stroke="#D4AF37"
          strokeOpacity="0.3"
          strokeWidth="1"
        />
        <circle cx="720" cy="34" r="3.5" fill="#D4AF37" fillOpacity="0.8" />
      </svg>
    </div>
  );
}
